module.exports = __webpack_public_path__ + "assets/img/SOL.163cadeb.png";